import { useQuery } from '@tanstack/react-query';
import {
  getRiskState,
  getOnchainErrors,
  getSystemInstant,
  getWalletBalance,
  getPositionsStats,
  getActivePositions,
} from '../services/api';

/**
 * Polling indépendant par carte : une query en erreur n'effondre pas les autres.
 * Intervalles adaptés à la volatilité de chaque source.
 */
export function useCockpitData() {
  const risk = useQuery({
    queryKey: ['cockpit', 'risk'],
    queryFn: getRiskState,
    refetchInterval: 2000,
  });
  const errors = useQuery({
    queryKey: ['cockpit', 'onchain'],
    queryFn: () => getOnchainErrors(300),
    refetchInterval: 2000,
  });
  const instant = useQuery({
    queryKey: ['cockpit', 'instant'],
    queryFn: getSystemInstant,
    refetchInterval: 2000,
  });
  const wallet = useQuery({
    queryKey: ['cockpit', 'wallet'],
    queryFn: getWalletBalance,
    refetchInterval: 10000,
  });
  const stats = useQuery({
    queryKey: ['cockpit', 'stats'],
    queryFn: getPositionsStats,
    refetchInterval: 15000,
  });
  const positions = useQuery({
    queryKey: ['cockpit', 'active'],
    queryFn: () => getActivePositions(5),
    refetchInterval: 3000,
  });

  return { risk, errors, instant, wallet, stats, positions };
}
